import { settings } from '@/pages/layout/store';
import { useRouter, useRoute } from '@/utils';

function useGetRouteInstance() {
  const router = useRouter();
  const route = useRoute();
  return {
    router,
    route,
  };
}
export default () => {
  const { router, route } = useGetRouteInstance();

  const clickLogo = () => {
    setTimeout(() => {
      router.push({
        path: '/home',
      });
    });
  };
  return {
    router,
    route,
    clickLogo: () => {
      settings.menuRender = false;
      settings.defaultHeaderMenuSelect = '';
      settings.defaultSideMenuSelect = '';
      clickLogo();
    },
    settings,
  };
};
